import { Field } from 'formik';
import { useIntl } from 'react-intl';
import SelectField from '../../formik/SelectField';
import TextField from '../../formik/TextField';

const CreditCardForm = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="form option__form">
      <div className="form__row">
        <div className="form__field-container">
          <Field
            name="creditCard.issuer"
            component={SelectField}
            label={formatMessage({ id: 'payment.paymentMethod.creditCardForm.issuer.label' })}
            options={['visa', 'mastercard', 'amex'].map(value => ({
              value,
              label: formatMessage({ id: `payment.paymentMethod.creditCardForm.issuer.options.${value}` })
            }))}
            data-test-id="payment-creditcard-issuer"
          />
        </div>
      </div>
      <div className="form__row">
        <div className="form__field-container" style={{ flex: 3 }}>
          <Field
            name="creditCard.number"
            component={TextField}
            label={formatMessage({ id: 'payment.paymentMethod.creditCardForm.number' })}
            data-test-id="payment-creditcard-number"
          />
        </div>
        <div className="form__field-container">
          <Field
            name="creditCard.expiration"
            component={TextField}
            label={formatMessage({ id: 'payment.paymentMethod.creditCardForm.expiration' })}
            data-test-id="payment-creditcard-expiration"
          />
        </div>
      </div>
      <div className="form__row">
        <div className="form__field-container" style={{ flex: 3 }}>
          <Field
            name="creditCard.holder"
            component={TextField}
            label={formatMessage({ id: 'payment.paymentMethod.creditCardForm.holder' })}
            data-test-id="payment-creditcard-holder"
          />
        </div>
        <div className="form__field-container">
          <Field
            name="creditCard.cvv"
            component={TextField}
            label={formatMessage({ id: 'payment.paymentMethod.creditCardForm.cvv' })}
            data-test-id="payment-creditcard-cvv"
          />
        </div>
      </div>
    </div>
  );
};

export default CreditCardForm;
